import { BreakpointChip } from '@app/components/base/BreakpointChip';
import { AuthWrapper } from '@app/core/auth/authentication';
import { AppRootRoutes } from '@app/core/auth/flow/AppRootRoutes';
import { ErrorBoundary } from '@app/core/error/ErrorBoundary';
import { NotificationsContainer } from '@app/core/notifications';
import { RouterWrapper } from '@app/core/routing/RouterWrapper';
import { ThemeProvider } from '@mui/material';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { SplashLoader } from '@ui/components';
import { HelmetProvider } from 'react-helmet-async';
import { Switch } from 'react-router';
import { LoginPage } from '../auth/flow';
import { GrowthBookProviderWrapper } from '../integrations/growthbook/GrowthBookProviderWrapper';
import { PostHogProviderWrapper } from '../integrations/posthog/PostHogProviderWrapper';
import { queryClient } from '../integrations/react-query/react-query';
import { AppRoute } from '../routing/AppRoute';
import { FontSwitcher } from '../ui/FontSwitcher';
import { muiTheme } from '../ui/mui-theme';
import { HtmlTags } from './HtmlTags';
import { LanguageProvider } from './LanguageProvider';
import { ZustandPersistGate } from './ZustandPersistGate';

// to preserve import when tools are commented out
const _ReactQueryDevtools = ReactQueryDevtools;

export function Root() {
  return (
    <GrowthBookProviderWrapper>
      <HelmetProvider>
        <LanguageProvider>
          <ThemeProvider theme={muiTheme}>
            {/* <CssBaseline /> */}
            <ErrorBoundary errScreen>
              <HtmlTags />
              <BreakpointChip />
              <FontSwitcher />
              <ZustandPersistGate fallback={<SplashLoader />}>
                <QueryClientProvider client={queryClient}>
                  <RouterWrapper>
                    <NotificationsContainer />
                    <PostHogProviderWrapper>
                      <AuthWrapper>
                        <Switch>
                          <AppRoute path="/login" component={LoginPage} />
                          <AppRootRoutes />
                        </Switch>
                      </AuthWrapper>
                    </PostHogProviderWrapper>
                  </RouterWrapper>
                  <_ReactQueryDevtools initialIsOpen={false} buttonPosition={'top-left'} />
                </QueryClientProvider>
              </ZustandPersistGate>
            </ErrorBoundary>
          </ThemeProvider>
        </LanguageProvider>
      </HelmetProvider>
    </GrowthBookProviderWrapper>
  );
}
